import {Box, Link} from '@miro-site/core'
import {transparentize} from 'polished'
import React from 'react'
import styled from 'styled-components'

export interface ExternalLinkProps {
  title: string
  link: string
  onLinkClick?: React.MouseEventHandler<HTMLAnchorElement>
}

const ExternalLink: React.FC<ExternalLinkProps> = ({title, link, onLinkClick}) => {
  return (
    <Box $styles={{width: [325, 550, 550, 550]}} $mb={[52, 80, 80, 80]}>
      <TopStroke />
      <BlogLink
        $mt={[24, 40, 40, 40]}
        href={link}
        onClick={e => {
          if (onLinkClick) {
            e.preventDefault()
            onLinkClick(e)
          }
        }}
      >
        {title}
      </BlogLink>
    </Box>
  )
}

const BlogLink = styled(Link)`
  font-weight: 400;
  ${props => props.theme.normalizeStyles(props.theme.typography.paragraphs.p0)}

  border-bottom: none;

  transition: color ${props => props.theme.animation.transitionDuration};

  color: ${props => props.theme.colors.primaryIndigo};

  &:hover {
    color: ${props => props.theme.colors.primaryBlue};
  }
`

const TopStroke = styled.div`
  height: 1px;
  border-radius: 2px;
  background-color: ${props => transparentize(0.8, props.theme.colors.primaryIndigo)};
`

export default ExternalLink
